export const dataConstants = {
	exemptBy: 'exemptBy',
	isWaivable: 'isWaivable',
};

export const testContent = {
	inNetworkHeader: `We're in your insurance network!`,
	inNetworkDescription: `You'll only be asked to pay with a copay when you're actually receiving services. So, while you'll pay the membership fee, any costs for visits, labs, or medications will be smoothly processed through your insurance when you need them.`,
	inNetworkCoveredDescription: `You'll only be asked to pay with a copay when you're actually receiving services. So any membership cost, visits, labs, or medications will be smoothly processed through your insurance.`,
	outNetworkHeader: `Unfortunately, we're not in your insurance network yet.`,
	outNetworkDescription: `Our team is hard at work negotiating contracts with insurance companies, and we'll let you know when we're able to join your insurance network.`,
};
